import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'meli-edit-form-multi-table',
    templateUrl: './meli-edit-form-multi-table.component.html',
    styleUrls: ['./meli-edit-form-multi-table.component.scss'],
    standalone: false
})
export class MeliEditFormMultiTableComponent implements OnInit {

  @Input('dataMultiTable') dataMultiTable:Object[] = [];
  @Output('dataMultiTableChange') dataMultiTableChange:EventEmitter<Object[]> = new EventEmitter<Object[]>();
  
  @Input('dataMultiTableConfig') dataMultiTableConfig:{columnName:string,columnDesc:string, colspan:number, format:string,dateFromFormat?:string, dateFormat?:string}[] = [];
  colsCount:number = 0;
  allComplete: boolean = false;
  hasSelect: boolean =false;
  selectedCount: number = 0;
  constructor() { }

  ngOnInit(): void {
    
    this.colsCount  = Object.keys(this.dataMultiTableConfig).length + 1;
        
  }

  someComplete(): boolean {
    if (this.dataMultiTable == null) {
      return false;
    }
    return this.dataMultiTable.filter(t => t['selected']==true).length > 0 && !this.allComplete;
  }

  updateAllComplete(){
    this.allComplete = this.dataMultiTable != null && this.dataMultiTable.every(t => t['selected']);
    this.hasSelect = this.dataMultiTable != null && this.dataMultiTable.some(t=>t['selected']);
    this.selectedCount = this.dataMultiTable.filter(t=>t['selected']).length;
  }

  removeItens(){
      this.dataMultiTable = [...this.dataMultiTable.filter(d=>d['selected']!=true)];
      this.allComplete = this.dataMultiTable != null && this.dataMultiTable.every(t => t['selected']);
      this.hasSelect = this.dataMultiTable != null && this.dataMultiTable.some(t=>t['selected']);
      this.selectedCount = this.dataMultiTable.filter(t=>t['selected']).length;
      this.dataMultiTableChange.emit(this.dataMultiTable);
  }

  onSelectCheckBox(completed:boolean){
  
    this.allComplete = completed;
    this.hasSelect = completed;
    
    if (this.dataMultiTable == null || this.dataMultiTable.length <=0) {
      return;
    }
    
    this.dataMultiTable.forEach(t => (t['selected']  = completed));

    this.selectedCount = this.dataMultiTable.filter(t=>t['selected']).length;
  }
}
